import {LanguageId} from "../utils/utils";

export enum ShopSectionType {
  EVENT = 'event',
  PROTOPASS = 'protopass',
  DONATION = 'donation',
  VOUCHER = 'voucher',
  METAPRODUCT = 'metaproduct',
}

export enum ShopSectionDisplay {
  SHOW = 'show',
  HIDE = 'hide',
}

export interface ShopSection {
  position: number;
  type: ShopSectionType;
  display: ShopSectionDisplay;
  language?: ShopSectionLanguage;
  languages?: ShopSectionLanguage[];
}

export interface ShopSectionLanguage {
  language_id: LanguageId;
  name: string;
}
